var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cost-details-component"},[_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"sub-title"},[_c('span',[_vm._v("费用明细")]),(_vm.required)?_c('span',{staticClass:"star"},[_vm._v("*")]):_vm._e()]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cost-details"},[_c('span',[_c('i',{staticClass:"el-icon-download"}),_vm._v(" 从账本导入 ")])])
}]

export { render, staticRenderFns }